import { useQuery } from '@tanstack/react-query';

import Axios from '@/lib/axios-instance';

export const getWidgetSettings = async () => {
  try {
    const response = await Axios.get(`/chat_widget_settings`);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(
        `${error.response.data?.meta?.message || 'An error occurred'}`,
      );
    }
    throw new Error(error.message || 'Network Error');
  }
};

export const useGetWidgetSettings = () => {
  const widgetSettings = useQuery({
    queryKey: ['get_widget_settings'],
    queryFn: () => getWidgetSettings(),
  });

  return widgetSettings;
};
